import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/about';
import Catalog from './pages/catalog';
import Contact from './pages/contact';
import Sertificat from './pages/sertificat';
import Terms from './pages/terms';
import Privacy from './pages/privacy';
import MarlevaProductia from './pages/marleva';
import PokryttiaPage from './pages/pokryttia';
import ShovniPage from './pages/shovni';
import OdyagPage from './pages/odyag';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/catalog/marleva" element={<MarlevaProductia />} />
            <Route path="/catalog/pokryttia" element={<PokryttiaPage />} />
            <Route path="/catalog/shovni" element={<ShovniPage />} />
            <Route path="/catalog/odyag" element={<OdyagPage />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/certificates" element={<Sertificat />} /> */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
